import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class PerformanceService {
  private isActive = false;

  activate() {
    this.isActive = true;
    this.reportOnLoad();
  }

  deactivate() {
    this.isActive = false;
  }

  // private reportOnLoad() {
  //   if (this.isActive) {
  //     window.addEventListener(
  //       'load',
  //       () => {
  //         const [nav] = performance.getEntriesByType(
  //           'navigation'
  //         ) as PerformanceNavigationTiming[];

  //         if (nav && nav.loadEventEnd > 0) {
  //           const report = {
  //             '⏳ Time to First Byte (TTFB)':
  //               nav.responseStart - nav.requestStart,
  //             '📜 DOM Interactive': nav.domInteractive - nav.startTime,
  //             '📥 DOM Content Loaded':
  //               nav.domContentLoadedEventEnd - nav.startTime,
  //             '✅ DOM Complete': nav.domComplete - nav.startTime,
  //             '⏱️ Total Load Time': nav.loadEventEnd - nav.startTime,
  //           };

  //           console.table(report);
  //         } else {
  //           console.warn('⚠️ loadEventEnd aún no está disponible o es 0');
  //         }
  //       },
  //       { once: true }
  //     ); // Solo la primera vez
  //   }
  // }

  private reportOnLoad(): void {
    if (!this.isActive) return;

    const generateReport = () => {
      const [nav] = performance.getEntriesByType(
        'navigation'
      ) as PerformanceNavigationTiming[];

      if (!nav) {
        console.warn('⚠️ No se encontró entrada de navegación');
        return;
      }

      const loadTime = nav.loadEventEnd - nav.startTime;

      if (loadTime <= 0) {
        console.warn('⚠️ loadEventEnd aún no disponible o es 0');
        return;
      }
      const toSec = (ms: number) => (ms / 1000).toFixed(2) + ' s';

      const report = {
        '⏳ Time to First Byte (TTFB)': toSec(
          nav.responseStart - nav.requestStart
        ),
        '📜 DOM Interactive': toSec(nav.domInteractive - nav.startTime),
        '📥 DOM Content Loaded': toSec(
          nav.domContentLoadedEventEnd - nav.startTime
        ),
        '✅ DOM Complete': toSec(nav.domComplete - nav.startTime),
        '⏱️ Total Load Time': toSec(loadTime),
      };
      // const report = {
      //   '⏳ Time to First Byte (TTFB)': nav.responseStart - nav.requestStart,
      //   '📜 DOM Interactive': nav.domInteractive - nav.startTime,
      //   '📥 DOM Content Loaded': nav.domContentLoadedEventEnd - nav.startTime,
      //   '✅ DOM Complete': nav.domComplete - nav.startTime,
      //   '⏱️ Total Load Time': loadTime,
      // };

      const noPro =
        environment.envName === 'local' || environment.envName === 'dev';

      if (noPro) {
        console.log(report);
      }

      // console.table(report);

      // Puedes enviar el reporte a un backend aquí si lo deseas en el futuro
      // this.sendToServer(report);
    };

    // Si la página ya se cargó, ejecutamos de inmediato
    if (document.readyState === 'complete') {
      generateReport();
    } else {
      window.addEventListener('load', generateReport, { once: true });
    }
  }
}
